<script setup>
/** 每日积分发放 vs 消耗：两根并排柱，发放 success 色、消耗主色。 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import EChart from '../EChart.vue'
import { categoryAxis, chartBase, chartTheme, valueAxis } from '../chart-theme.js'
import { useAdminTheme } from '../../composables/useAdminTheme.js'

const props = defineProps({
  items: { type: Array, required: true },
})

const emit = defineEmits(['select'])
const { t } = useI18n()
const { theme: themeName } = useAdminTheme()

const option = computed(() => {
  const theme = chartTheme(themeName.value)
  const granted = t('visualGameAdmin.billing.dashboard.charts.pointsGranted')
  const spent = t('visualGameAdmin.billing.dashboard.charts.pointsSpent')
  return {
    ...chartBase(theme),
    color: [theme.success, theme.bar],
    grid: { top: 56, left: 16, right: 16, bottom: 12, containLabel: true },
    legend: { top: 8, textStyle: { color: theme.textMuted }, data: [granted, spent] },
    tooltip: { ...chartBase(theme).tooltip, valueFormatter: value => Number(value).toLocaleString('en-US') },
    xAxis: {
      ...categoryAxis(theme),
      data: props.items.map(item => item.date),
      axisLabel: { color: theme.textMuted, hideOverlap: true, formatter: value => value.slice(5) },
    },
    yAxis: { ...valueAxis(theme), minInterval: 1 },
    series: [
      { name: granted, type: 'bar', barMaxWidth: 18, data: props.items.map(item => item.points_granted) },
      { name: spent, type: 'bar', barMaxWidth: 18, data: props.items.map(item => item.points_spent) },
    ],
  }
})
</script>

<template>
  <EChart :option="option" height="320px" @select="emit('select', props.items[$event.index])" />
</template>
